import { ISchemaFields, ISchemaForm, IUiFields } from '../../../../common/SchemaForm/utils';

export const fieldSchema: ISchemaFields = ({ formProps }) => {
  const { intl } = formProps || {};
  return {
    name: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'supply.groupName' }),
      placeholder: intl.formatMessage({ id: 'supply.groupNameEnter' }),
      autoFocus: true,
      register: {
        required: true,
      },
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'info',
      fields: ['name'],
    },
  ];
};

export const groupSupplyFormSchema: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
};
